import React from "react"
import styled from "styled-components"
import L from "@/containers/MoneyFortune/View/decorate/L"

export default function Title({
  title0,
  title1,
  title2,
  title3,
  title4,
  type,
  onClick,
  desc
}) {
  return (
    <Wrapper className={type === "question" && "question"} onClick={onClick}>
      <LWrapper>
        <L rotate="0" type={type} />
        <L rotate="90" type={type} />
        <L rotate="180" type={type} />
        <L rotate="270" type={type} />
      </LWrapper>
      {title0 && <div className="row1">{title0}</div>}
      <div className="row1">
        <h1>{title1}</h1>
        <h1>{title2}</h1>
      </div>
      {title3 && (
        <div className="row2">
          <h1>{title3}</h1>
          <h1>{title4}</h1>
        </div>
      )}
      {desc && (
        <DescWrapper>
          <h3>{desc}</h3>
        </DescWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 42px 100px;
  background-color: rgba(0, 255, 238, 0.116);
  backdrop-filter: blur(3px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 1000px) {
    padding: 42px;
  }
  @media (max-width: 400px) {
    padding: 30px 10px;
  }
  .row1 {
    display: flex;
    gap: 0px;
    align-items: center;
  }
  .row2 {
    display: flex;
    gap: 60px;
    @media (min-height: 1000px) {
      gap: 0;
    }
    @media (max-width: 1000px) {
      gap: 0;
    }
  }
  h1 {
    color: #00fff0;
    font-size: 98px;
    line-height: 1.3;
    letter-spacing: 10px;
    margin: 0;
    text-shadow:
      0 0 40px #00ffeeaa,
      0 0 20px #000;
    @media (max-width: 1000px) {
      font-size: 60px;
    }
    @media (max-width: 768px) {
      font-size: 36px;
    }
    @media (max-width: 430px) {
      font-size: 32px;
    }
  }
  &.question {
    background-color: rgba(0, 255, 238, 0);
    align-items: center;
    padding: 32px 40px;
    /* height: 100px; */
    position: relative;
    @media (max-width: 768px) {
      padding: 30px 16px;
      max-height: 100px;
    }

    .row1 {
      width: 100%;
      gap: 36px;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
      }

      h1 {
        font-size: 20px;
        letter-spacing: 2px;
        @media (max-width: 768px) {
          font-size: 16px;
          text-align: center;
        }
        &:nth-child(1) {
          color: #fff;
          font-size: 24px;
          position: absolute;
          top: -60px;
          text-shadow:
            0 0 40px #ffffffaa,
            0 0 20px #000;
        }
      }
    }
  }
`

const LWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  > div {
    position: absolute;
    width: 100px;
    height: 100px;
    &:nth-child(1) {
      position: absolute;
      top: 0;
      left: 0;
    }
    &:nth-child(2) {
      position: absolute;
      top: 0;
      right: 0;
    }
    &:nth-child(3) {
      position: absolute;
      bottom: 0;
      right: 0;
    }
    &:nth-child(4) {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
`
const DescWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 20px;
  h3 {
    text-align: end;
    color: #00fff0;
    font-size: 24px;
    margin: 0;
    letter-spacing: 4px;
    font-weight: 700;
    padding: 4px 8px;
    /* border-left: 4px solid #00fff0;
    border-right: 4px solid #00fff0; */
    text-shadow:
      0 0 40px #00ffeeaa,
      0 0 20px #000;
    animation: twinkling 5s infinite;
  }
  &:before {
    content: "";
    background-color: #00fff0;
    flex: 1;
    height: 2px;
  }
  &:after {
    content: "";
    background-color: #00fff0;
    flex: 0 0 20px;
    height: 2px;
  }

  @media (max-width: 1000px) {
    justify-content: center;
    margin-top: 20px;
    h3 {
      font-size: 18px;
    }
    &:before {
      content: "";
      flex: 1 0 20px;
      height: 2px;
    }
    &:after {
      content: "";
      flex: 1 0 20px;
      height: 2px;
    }
  }
  @media (max-width: 768px) {
    &:before {
      content: "";
      flex: 1 0 1px;
      height: 0.5px;
    }
    &:after {
      content: "";
      flex: 1 0 1px;
      height: 0.5px;
    }
  }

  @keyframes twinkling {
    0% {
      opacity: 1;
    }
    28% {
      opacity: 0.8;
    }
    30% {
      opacity: 0.3;
    }
    32% {
      opacity: 0.8;
    }
    35% {
      opacity: 0.3;
    }
    40% {
      opacity: 1;
    }
  }
`
